module.exports = __webpack_public_path__ + "static/img/fengmian-bgc.7a5c481.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common-img/fengmian-bgc.png
// module id = 74Wb
// module chunks = 17